export * from "./skyMaterial.js";
//# sourceMappingURL=index.js.map